<div tabindex="0" *ngIf="showText" class="count-down-text mb-2 text-center">
  <div *ngIf="timeLeft > 0">Termina em {{ getRemainingTime() }}</div>
  <div *ngIf="timeLeft <= 0">Tempo de espera esgotado</div>
</div>
<div #progressBar class="progress-bar">
  <div class="bar" [style.width.px]="width"></div>
</div>
